import { makeAutoObservable, runInAction } from 'mobx';
import type { ResponseDataRow } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { cmApi } from '@src/api';
import { preloaderStore } from '@stores/preloaderStore';
import type { CmApi, ControlGroupDto } from '@src/api';

export type ControlGroupDtoDefId = Omit<ControlGroupDto, 'id'> & { id: string };

class ControlGroupsStore {
  controlGroups: ControlGroupDtoDefId[] = [];

  api: CmApi;

  breadcrumbs: string[] = [];

  checked: ResponseDataRow[] = [];

  isChanged = false; // флаг, что справочник изменился для проверки загрузки в fetchReferences

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  setIsChanged = (value: boolean) => {
    this.isChanged = value;
  };

  setChecked = (value) => {
    this.checked = value;
  };

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.controlGroups.getControlGroups();

    runInAction(() => {
      this.controlGroups = data?.map((item) => ({ ...item, id: item.ctrlGroupCode ?? '' })) ?? [];
      this.isChanged = false;
    });
    preloaderStore.preloader(false);
  };

  groupDelete = async (controlGroups: ControlGroupDtoDefId[]) => {
    preloaderStore.preloader(true, 'удаление...');
    const promises = controlGroups.map((item) =>
      this.api.controlGroups.deleteControlGroupByCode(item.ctrlGroupCode ?? ''),
    );
    await Promise.all(promises);
    await this.fetch();
    preloaderStore.preloader(false);
  };

  clear = () => {
    this.breadcrumbs = [];
    this.checked = [];
  };
}

export const controlGroupsStore = new ControlGroupsStore({ api: cmApi });
